export const mockUiTemplate = [
    {
      "layout": "/kavida",
      "component": "ReportGenerator",
      "icon": "fas fa-database",
      "name": "Control Tower",
      "path": "/tour/command-tower",
      "tabs": []
    },
    {
      "layout": "/kavida",
      "component": "MilestoneTracker",
      "icon": "fa-solid fa-timeline",
      "name": "Order Manager",
      "path": "/tour/milestone-tracker",
      "tabs": []
    },
    {
      "layout": "/kavida",
      "component": "Intelligence",
      "icon": "fa-solid fa-globe",
      "name": "Global Risks",
      "path": "/tour/intelligence",
      "tabs": [
        "all",
        "global impact",
        "esg",
        "delays",
        "supplier market",
        "compliance",
        "environmental",
        "commodities"
      ]
    },
    {
      "layout": "/kavida",
      "component": "MarketResearch",
      "icon": "fa-solid fa-newspaper",
      "name": "News Desk",
      "path": "/tour/market-research",
      "tabs": []
    },
    {
      "layout": "/kavida",
      "component": "MarketResearch",
      "icon": "fa-solid fa-magnifying-glass-chart",
      "name": "Contacts",
      "path": "/tour/market-research",
      "tabs": []
    }
  ]